import {CONSENTS} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(CONSENTS)
